import React, { useEffect, useState } from "react";
import { BrowserRouter } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import { Wrapper } from "@googlemaps/react-wrapper";
import { isAndroid, isIOS } from "react-device-detect";
import firebaseConfigFunction from "constants/firebase";
import MainComponent from "MainComponent";
import { authenticationActions as authActions } from "actions";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import Notification from "./Notification";
import { homeService } from "./services/home.service";
import { homeActions } from "actions";
let messaging = null;

const AppWrapperFn = (props) => {
  const { axiosErrorResponse, getOrganizationDetails, organizationInfo } =
    props;

  const [firebaseObj, setFirebaseObj] = useState(null);

  useEffect(() => {
    getOrganizationDetails();
  }, []);

  useEffect(() => {
    const firebaseToken = localStorage?.getItem("firebase_token");
    if (organizationInfo?.app) {
      const firebaseData = firebaseConfigFunction(
        organizationInfo?.app?.appSettings
      );
      setFirebaseObj(firebaseData);
      const widgetEnabled = sessionStorage.getItem("widgetEnabled");

      if (
        organizationInfo?.organizationOptionJson?.branchIoLink &&
        widgetEnabled?.toLowerCase() === "n"
      ) {
        // init Branch
        window.branch.init(
          organizationInfo?.app?.appSettings?.branchIoKey,
          function (err, data) {
            console.log(
              err,
              data,
              organizationInfo?.app?.appSettings?.branchIoKey
            );
            let bannerObj = {
              icon: organizationInfo?.app?.appSettings?.appBannerConfig?.icon,
              title: organizationInfo?.app?.appSettings?.appBannerConfig?.title,
              description:
                organizationInfo?.app?.appSettings?.appBannerConfig
                  ?.description,
              iframe: false,
              showMobile: "true",
              showDesktop: "true",
              disableHide: "false",
              forgetHide: "false",
              downloadAppButtonText: data?.has_app ? "Open" : "Download",
              open_app: data?.has_app,
            };

            if (isIOS) {
              bannerObj.reviewCount =
                organizationInfo?.app?.appSettings?.appBannerConfig?.ios?.reviewCount;
              bannerObj.rating =
                organizationInfo?.app?.appSettings?.appBannerConfig?.ios?.rating;
            }

            if (isAndroid) {
              bannerObj.reviewCount =
                organizationInfo?.app?.appSettings?.appBannerConfig?.android?.reviewCount;
              bannerObj.rating =
                organizationInfo?.app?.appSettings?.appBannerConfig?.android?.rating;
            }

            window.branch.banner(
              bannerObj,
              `${organizationInfo?.organizationOptionJson?.branchIoLink}`
            );

            setTimeout(() => {
              const btnAccept = document.getElementById("branch-mobile-action");
              if (btnAccept) {
                btnAccept.onclick = function (ev) {
                  window.open(
                    organizationInfo?.organizationOptionJson?.branchIoLink,
                    "_blank",
                    "location=yes,height=570,width=1250, left=100, top=100, status=yes"
                  );
                  // window.location.href =
                  //   organizationInfo?.organizationOptionJson?.branchIoLink;
                  ev.preventDefault();
                };
              }
            }, 1000);
          }
        );
      }
      if (
        organizationInfo?.organizationOptionJson?.webPushNotificationFlag?.toLowerCase() ===
        "y"
      ) {
        try {
          if ("serviceWorker" in navigator) {
            messaging = getMessaging();
            if (!firebaseToken) {
              requestForToken(organizationInfo?.app?.appSettings?.vapIdKey);
              window.registerServiceWorker();
            }
          }
        } catch (e) {
          console.log("serviceWorker error", e);
        }
      }
    }
  }, [organizationInfo]);

  return (
    <>
      {organizationInfo?.app && firebaseObj !== null && (
        <Wrapper apiKey={firebaseObj?.apiKey}>
          <BrowserRouter basename="/">
            <MainComponent axiosErrorResponse={axiosErrorResponse} />
            {organizationInfo?.organizationOptionJson?.webPushNotificationFlag?.toLowerCase() ===
              "y" && <Notification />}
          </BrowserRouter>
        </Wrapper>
      )}
    </>
  );
};

const requestForToken = async (vapidKey) => {
  const registration = await navigator?.serviceWorker?.getRegistration();
  const subscribed = await registration?.pushManager?.getSubscription();

  if (subscribed) {
    return subscribed;
  }

  return getToken(messaging, {
    vapidKey: vapidKey,
  })
    .then((currentToken) => {
      if (currentToken) {
        console.log("current token for client: ", currentToken);
        homeService?.saveFirebaseToken(currentToken);
        localStorage?.setItem("firebase_token", currentToken);
        return currentToken;
        // Perform any other neccessary action with the token
      } else {
        // Show permission request UI
        console.log(
          "No registration token available. Request permission to generate one."
        );
      }
    })
    .catch((err) => {
      console.log("An error occurred while retrieving token. ", err);
    });
};

// Handle incoming messages. Called when:
// - a message is received while the app has focus
// - the user clicks on an app notification created by a service worker `messaging.onBackgroundMessage` handler.
const onMessageListener = () =>
  new Promise((resolve) => {
    const dispatch = useDispatch();

    onMessage(messaging, (payload) => {
      console.log("test", payload);
      const notificationTitle = payload.notification.title;
      const notificationOptions = {
        body: payload.notification.body,
      };

      window?.serviceWorkerRegistration?.showNotification(
        notificationTitle,
        notificationOptions
      );
      dispatch(homeActions.getFireBaseNotification(payload));

      resolve(payload);
    });
  });

const mapStateToProps = (state) => {
  return {
    organizationInfo: state.organizationInfo.data,
  };
};

const mapDispatchToProps = {
  getOrganizationDetails: () => authActions.getOrganizationDetails(),
};

const AppWrapper = connect(mapStateToProps, mapDispatchToProps)(AppWrapperFn);
export { AppWrapper, onMessageListener };


  
